<template>
    <SyncForm @update-opt="updateOpt"></SyncForm>
</template>

<script>
import { onMounted, reactive } from 'vue';
import SyncForm from '@/components/forms/SyncForm.vue'


export default {
    name: 'ShowTestrunCmd',
    components: {
        SyncForm,
    },
    setup(_, { emit }) {
        // #############
        // フォーム更新 #
        // #############
        const optDict = reactive({
            sync: "",
        })

        // 共通化
        const updateOpt = async (key, opt) => {
            optDict[key] = opt
            await updateOpts()
        }

        // #############
        // コマンド生成 #
        // #############
        const updateOpts = async () => {
            let createdOpt = ""
            for (const key in optDict) {
                if (optDict[key]) {
                    createdOpt += ` ${optDict[key]}`
                }
            }

            // コマンド生成&表示は親コンポーネント
            emit("update-cmd", createdOpt)
        }

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            await updateOpts()
        })

        return {
            // コマンド生成
            updateOpt,
        }
    }
}
</script>